import { Toast, ToastContainer } from "react-bootstrap";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
  CloseOutlined,
} from "@ant-design/icons";
import logoIcon from "../../assets/img/logo-icon.jpg";
import "./toast.css";

const TYPES = {
  success: { icon: <CheckCircleFilled />, className: "eh-toast-success" },
  error: { icon: <CloseCircleFilled />, className: "eh-toast-error" },
  warning: { icon: <ExclamationCircleFilled />, className: "eh-toast-warning" },
  info: { icon: <InfoCircleFilled />, className: "eh-toast-info" },
};

function ToastMsg({ show, setShow, msg, type = "success", action, delay = 3500 }) {
  const cfg = TYPES[type] || TYPES.success;

  return (
    <ToastContainer position="bottom-end" className="eh-toast-container p-3">
      <Toast
        onClose={() => setShow(false)}
        show={show}
        delay={delay}
        autohide
        className={`eh-toast ${cfg.className}`}
      >
        <Toast.Body className="eh-toast-body">
          <span className="eh-toast-icon">
            <img src={logoIcon} alt="Visum Oftalmología" className="eh-toast-logo" style={{ background: "#fff", objectFit: "contain" }} />
            <span className="eh-toast-badge">{cfg.icon}</span>
          </span>
          <span className="eh-toast-msg">{msg}</span>
          {action && (
            <button
              type="button"
              className="eh-toast-action"
              onClick={() => {
                action.onClick?.();
                setShow(false);
              }}
            >
              {action.label}
            </button>
          )}
          <button
            type="button"
            className="eh-toast-close"
            onClick={() => setShow(false)}
            aria-label="Cerrar"
          >
            <CloseOutlined />
          </button>
          <span className="eh-toast-progress" />
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default ToastMsg;
